import EventEmmiter from '../helpers/EventEmmiter';
import { generateUUID } from '../helpers/common';
require('./style.scss');

const MODE_READ_ONLY = 'MODE_READ_ONLY';

export class GoogleMapPreviewModel {

    iframe = null;
    iframeWindow = null;
    plan = {};
    _mode = MODE_READ_ONLY;

    constructor(plan = {}, editable) {
        for (let key in plan) {
            if (plan.hasOwnProperty(key)) {
                this[key] = plan[key];
            }
        }
        this.iframeUrl = `build/dist/wireframe.html?token=${generateUUID()}`;
    }

    get mode() {
        return this._mode;
    }

    set mode(mode) {
        this._mode = mode;
    }
}

export default class GoogleMapPreview extends EventEmmiter {

    _container = null;
    _listener = null;
    _preview = null;
    _transferOrigin = '*';
    _iframeId = 'e3-googlemap-iframe__preview__iframe';

    constructor(container, editable = false, params={type: '2d', metrical: true, iframeID: 'e3-planner-preview'}) {
        super();
        let plan = {};
        this._container = container;
        this._preview = new GoogleMapPreviewModel({plan}, editable);
        this._iframeId = params.iframeID ? params.iframeID : this._iframeId;

        this._init(params);
    }

    _init(params){
        this._bindEvents();
        this._createIframe(params);
    }

    _serialize(obj){
        var str = "";
        for (var key in obj) {
            if (str != "") {
                str += "&";
            }
            str += key + "=" + encodeURIComponent(obj[key]);
        }

        return str;
    }

    _createIframe(params) {
        let urlParams = this._serialize(params);
        this._preview.iframe = document.createElement('iframe');
        // this._preview.iframe.width = '290';
        this._preview.iframe.id = this._iframeId;
        this._preview.iframe.onload = () => {
            this._preview.iframeWindow = this._preview.iframe.contentWindow;
        };

        this._preview.iframe.src = this._preview.iframeUrl + '?' + urlParams;

        this.addLoading();

        this._container.appendChild(this._preview.iframe);
    }

    addLoading() {
        this._container.classList.add('loading');
    }

    removeLoading() {
        this._container.classList.remove('loading');
    }

    _bindEvents() {
        this._listener = this._messageListener.bind(this);

        window.addEventListener('message', this._listener);
    }

    _messageListener(message) {
        if (this._preview.iframe.contentWindow !== message.source) return;

        switch (message.data.event) {
            case 'e3.googlemap.ready':
                this._fireEvent('ready');
                this.removeLoading();
                break;
        }
    }

    _loadPlan(plan = {}, type = '', clean = false, defaultPlan) {
        this._preview.iframeWindow = !this._preview.iframeWindow ? document.getElementById(this._iframeId).contentWindow : this._preview.iframeWindow;
        this._preview.iframeWindow.postMessage({event: 'e3.admin.config', config:plan, defaultPlan, type, clean}, this._transferOrigin);

        this._fireEvent('disabled', !this._checkPlanVertices(plan));
    }

    _checkPlanVertices(plan) {
        if (!plan || !plan.layers) return false;

        return Object.keys(plan.layers).some((id) => {
            return Object.keys(plan.layers[id].vertices).length > 2;
        })
    }

    destroy() {
        super.destroy();
        window.removeEventListener('message', this._listener);
        this._container.appendChild(this._preview.iframe);
        for(let obj in this._preview){
            this._preview[obj] = null;
        }
        this._preview = null;
    }

    sendAction(action, status) {
        if(!this._preview) return ;
        this._preview.iframeWindow = !this._preview.iframeWindow ? document.getElementById(this._iframeId).contentWindow : this._preview.iframeWindow;
        this._preview.iframeWindow.postMessage({event: 'e3.floorplan.action', action:action, status:status}, this._transferOrigin);
    }

    minimize(scene) {
        this._preview.iframe.classList.remove('full-screen');
        this._minimizeScreen();
        this._fireEvent('full.screen', {active: false, scene});
        this._preview.mode = MODE_READ_ONLY;
    }


    _minimizeScreen() {
        this._preview.iframeWindow = !this._preview.iframeWindow ? document.getElementById(this._iframeId).contentWindow : this._preview.iframeWindow;
        this._preview.iframeWindow.postMessage({event: 'e3.admin.minimize-screen'}, this._transferOrigin);
    }
}
